import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const OauthInfo = props => {
  return (
    <Fragment>
      <h3>Oauth Info</h3>
      <ul>
        <li>
          <b>Consumer Key:</b> {props.log.params.oauth_consumer_key}
        </li>
        <li>
          <b>Nonce:</b> {props.log.params.oauth_nonce}
        </li>
        <li>
          <b>Signature:</b> {props.log.params.oauth_signature}
        </li>
        <li>
          <b>Signature Method:</b> {props.log.params.oauth_signature_method}
        </li>
        <li>
          <b>Timestamp:</b> {props.log.params.oauth_timestamp}
        </li>
        <li>
          <b>Version:</b> {props.log.params.oauth_version}
        </li>
      </ul>
    </Fragment>
  )
}
export default OauthInfo

OauthInfo.propTypes = {
  log: PropTypes.object,
}
